import '@/utils/onError';
// for android<5
// import 'core-js/stable';
// import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import intl from './utils/i18n';
import { LANG } from '@/utils/locale';
import { setMomentLocales, pullAllTranslation } from '@/utils/transifyHandler';
import { loadJS } from '@/utils/loadUtil';

import coreStore from '@/stores/core';
import App from '@/App';
import reporter, { reportPageName } from './utils/report';
import { TRACKING_OPERATION, TRACKING_PAGE } from './utils/tracking/constants';
import { mdapReporter } from './utils/mdap/reporter';
import transifyReporter from '@/utils/transifyReporter';
import * as OfflinePluginRuntime from '@lcdp/offline-plugin/runtime';
import { setSearchUrl } from '@/config/search';
import { loadCsSharedComponent } from '@/utils/hooks/loadCsSharedComponent';
import { initBridge } from '@/bridge';
// bridge初始化
initBridge();

console.log('TODO:', 'bootstarp app');
function main() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const entry = urlSearchParams.get('from');

  if (entry === 'TFESimulate') {
    const params = Object.fromEntries(
      new URLSearchParams(window.location.search),
    );
    params.__pc__ = 1;
    window.bridgeCallHandler('navigateAppRL', {
      apprl: '/rn/@shopee-rn/web-chatbot-rn/HOME',
      params,
    });
  } else {
    init();
  }
}


// const from = getFromInUrl();

// if (from === 'DriverAPPOngoingOrderPage' || from === 'DriverAPPOrderDetailsPage') {
//   console.log('设置cookie');
//   document.cookie = '_SPC_PFB=pfb-shopeefooddriver';
// }
// [live-chat-split-change]
// 将React和ReactDOM挂载到全局的window.CsChat属性上供SDK使用
if (!window.CsChat) {
  window.CsChat = {};
}
window.CsChat.React = React;
window.CsChat.ReactDOM = ReactDOM;

window.addEventListener('load', async () => {
  OfflinePluginRuntime.install({
    onUpdating: () => {
      console.log('SW Event:', 'onUpdating');
    },
    onUpdateReady: () => {
      console.log('SW Event:', 'onUpdateReady');
      // Tells to new SW to take control immediately
      OfflinePluginRuntime.applyUpdate();
    },
    onUpdated: () => {
      console.log('SW Event:', 'onUpdated');
      // Reload the webpage to load into the new version
      // window.location.reload();
    },
    onUpdateFailed: () => {
      console.log('SW Event:', 'onUpdateFailed');
    },
  });

  await mdapReporter.lazyInit();
  mdapReporter.sendPvCount();

  // 在浏览器空闲时获取全量transify key
  pullAllTranslation();

});


async function init() {
  setMomentLocales();
  if (window.chatbotGlobalInfo && window.chatbotGlobalInfo.lang === LANG) {
    const { liteTranslation, storedTranslation } = window.chatbotGlobalInfo;
    const translation = liteTranslation || storedTranslation;
    intl.init({
      currentLocale: LANG,
      locales: translation || { [LANG]: {} },
    });
    translation?.[LANG] && transifyReporter.setKeyMap(translation[LANG]);
  } else {
    const transifyKey = window.ShopeeChatbot.transifyKey;
    loadJS(`/static/translation/${transifyKey != null ? transifyKey + '/' : ''}${LANG}_lite.js?v=${+new Date()}`, () => {
      const translation = window.chatbotGlobalInfo?.liteTranslation;
      intl.init({
        currentLocale: LANG,
        locales: translation || { [LANG]: {} },
      });
      translation?.[LANG] && transifyReporter.setKeyMap(translation[LANG]);
    });
  }

  coreStore.safeGetStore('firstInit').UPDATE_LOADING_TO_GET_I18N(false);

  ReactDOM.render(<App stores={{ coreStore }} />, document.getElementById('app'));

  // [live-chat-split-change]
  // 渲染完去加载LiveChat SDK不阻塞渲染

  // 异步加载live chat逻辑，避免阻塞首屏渲染
  import('@/utils/liveChatSDK').then((module) => {
    const { default: initLiveChatSDK } = module;
    setTimeout(() => {
      initLiveChatSDK();
    }, 0);
  });
  // 异步设置searchUrl
  await setSearchUrl();


  window.ShopeeChatbot.isJSLoaded = true;

  const { hasJSTimeout, hasCdnJSFailed } = window.ShopeeChatbot;

  if (!hasJSTimeout) {
    if (hasCdnJSFailed) {
      // JS 资源重试主站成功
      reporter.apiBatchReport({ type: 'count', value: { label: 'fallback_js_pv_total' } });
    } else {
      reporter.apiBatchReport({ type: 'count', value: { label: 'cdn_js_pv_total' } });
    }
  }

  reporter.apiBatchReport({ type: 'count', value: { label: 'js_pv_total' } });

  reporter.biReport({
    page_type: TRACKING_PAGE.GAME_HIPO_TRACK,
    operation: TRACKING_OPERATION.ACTION_HIPO,
    data: {
      page_name: reportPageName,
      hipo_type: 'action_page_pv',
    },
  });
  // TODO 后面切换为npm形式
  window.React = React;
  window.ReactDOM = ReactDOM;
  await loadCsSharedComponent();

}

// 初始化
main();

// pfb
// if (ENVIRONMENT === 'test' || ENVIRONMENT === 'uat') {
//   import('@infra/pfb-selector');
// }

